import { BikeOption } from "../models/BikeOption"
import { UserBikes_bikes_data } from "../gql/__generated__/UserBikes"

export const createBikeOption = (bike: UserBikes_bikes_data): BikeOption => {
  return {
    id: bike.id as string,
    label: `${bike?.attributes?.name}${bike?.attributes?.brand ||bike?.attributes?.model ? ` (${bike?.attributes?.brand}  ${bike?.attributes?.model})` : ''}`,
  }
}
